import React from "react";
import { cn } from "../../utils/cn";

interface FormFieldProps {
  label: string;
  error?: string;
  children: React.ReactNode;
}

export const FormField = ({ label, error, children }: FormFieldProps) => (
  <div className="flex flex-col gap-2">
    <label className="text-[12px] font-medium text-content-label">{label}</label>
    {children}
    {error && <span className="text-[11px] text-content-error">{error}</span>}
  </div>
);

const baseInputClass =
  "w-full rounded-[6px] px-4 py-[13px] text-[14px] font-normal outline-none bg-surface-input text-content-body placeholder:text-content-muted";

export const TextInput = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(baseInputClass, className)}
    {...props}
  />
));
TextInput.displayName = "TextInput";

export const TextArea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(baseInputClass, "resize-none", className)}
    {...props}
  />
));
TextArea.displayName = "TextArea";
